import { router as Router } from '@inertiajs/core'

export const router = Router
export { default as Head } from './Head'
export { InertiaLinkProps, default as Link } from './Link'
export { default as createInertiaApp } from './createInertiaApp'
export { default as useForm } from './useForm'
export { default as usePage } from './usePage'
export { default as useRemember } from './useRemember'
